import React from 'react';
import { Reveal } from './Reveal';
import { steps } from '../data/howItWorks';
export function HowItWorksSection() {
  return <section className="bg-brand-main px-4 py-20 md:py-24" data-id="element-122" data-mp="fs663vmwdr50">
      <Reveal className="mx-auto max-w-5xl" data-id="element-123" data-mp="uhlrew3nt4db">
        <div className="mb-12 text-center" data-id="element-124" data-mp="uhc4xihtpfcd">
          <p className="mb-3 text-xs font-extrabold tracking-[0.18em] text-brand-ocean" data-id="element-125" data-mp="pj0tj3bvqws1">IN TRE PASSAGGI</p>
          <h2 className="text-3xl font-extrabold text-brand-deep md:text-4xl" data-id="element-126" data-mp="1sobv0qu1lo9">Come funziona</h2>
        </div>
        <ol className="grid gap-6 md:grid-cols-3" data-id="element-127" data-mp="3t0am5c824me3">
          {steps.map(({
          icon: StepIcon,
          title,
          description
        }, index) => <li key={title} className="flex flex-col items-center text-center" data-id="element-128" data-mp="aunxk6csldxj" data-mpi={index}>
              <span className="flex h-14 w-14 items-center justify-center rounded-full bg-brand-ocean text-white shadow-md" data-id="element-129" data-mp="6r7zr6ozl7j9">
                <StepIcon className="h-6 w-6" aria-hidden="true" data-id="element-130" data-mp="1m7gm78aadm9d" />
              </span>
              <span className="mt-4 text-[11px] font-extrabold tracking-[0.16em] text-brand-amber" data-id="element-131" data-mp="1i6o9u664b18v">
                PASSO {index + 1}
              </span>
              <h3 className="mt-1 text-lg font-bold text-brand-deep" data-id="element-132" data-mp="119h9wczjqv0w">{title}</h3>
              <p className="mt-2 max-w-xs text-sm leading-relaxed text-brand-gray" data-id="element-133" data-mp="11bkcdwhvygmi">{description}</p>
            </li>)}
        </ol>
      </Reveal>
    </section>;
}